import React from "react";
import { Dropdown } from "react-bootstrap";
import { useSearchParams } from "react-router-dom";
import FiPlus from "../../../assets/icons/plus";
import RxCross2 from "../../../assets/icons/cross";
import FaCheck from "../../../assets/icons/check";
import { contactUsReason } from "../../../utils/constants";

export default function ContactReasonFilter({ className = "" }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const reason = searchParams.get("reason");

  return (
    <Dropdown className={className}>
      <Dropdown.Toggle
        variant="transparent"
        id="dropdown-basic"
        className="border-0 hstack gap-1 px-0">
        {reason ? (
          <span className="bg-primary-light hstack align-items-center gap-1 border border-primary rounded-pill px-3 py-2 text-color">
            {contactUsReason?.find((option) => option.value === reason)?.label}
            <RxCross2 className="width-20 height-20" />
          </span>
        ) : (
          <span className="hstack align-items-center gap-1 border border-primary rounded-pill px-3 py-2 text-primary">
            <FiPlus className="width-20 height-20" />
            All
          </span>
        )}
      </Dropdown.Toggle>

      <Dropdown.Menu>
        {[{ value: "", label: "All" }, ...contactUsReason].map((option) => (
          <Dropdown.Item
            key={option.value}
            as={"p"}
            className="pointer m-0 py-2"
            onClick={(e) => {
              e.preventDefault();
              setSearchParams(
                (prev) => {
                  prev.set("reason", option.value);
                  return prev;
                },
                { replace: true }
              );
            }}>
            <div
              className={`hstack align-items-center gap-2 ${
                option.value === reason ? "fw-bold text-primary" : ""
              }`}>
              <span className="">{option.label}</span>
              {option.value === reason && <FaCheck />}
            </div>
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
}
